/** Pure team-score logic (no Firestore) — used by qualification + backtests. */

export function collectDirectReferredUids(parentUid, parentDocId, childrenByParentKey) {
  const seen = new Set();
  const out = [];
  [parentUid, parentDocId].filter(Boolean).forEach((key) => {
    (childrenByParentKey.get(key) || []).forEach((childUid) => {
      if (!childUid || seen.has(childUid)) return;
      seen.add(childUid);
      out.push(childUid);
    });
  });
  return out;
}

export function countQualifiedAtDepthUnderLeg(
  l1Uid,
  l1DocId,
  targetDepthFromUser,
  childrenByParentKey,
  uidToDocId,
  qualifiedUids
) {
  const hopsFromL1 = targetDepthFromUser - 1;
  if (hopsFromL1 <= 0) return 0;

  let frontier = collectDirectReferredUids(l1Uid, l1DocId, childrenByParentKey);
  for (let hop = 1; hop < hopsFromL1; hop++) {
    const next = [];
    for (const uid of frontier) {
      next.push(
        ...collectDirectReferredUids(uid, uidToDocId.get(uid), childrenByParentKey)
      );
    }
    frontier = next;
  }

  return frontier.filter((uid) => qualifiedUids.has(uid)).length;
}

export function computeCappedTeamScore({
  referrerUid,
  referrerUserDocId,
  rules,
  childrenByParentKey,
  uidToDocId,
  qualifiedUids,
}) {
  if (!rules) return 0;
  const level1Uids = collectDirectReferredUids(
    referrerUid,
    referrerUserDocId,
    childrenByParentKey
  );
  let teamScore = 0;
  for (const l1Uid of level1Uids) {
    const l1DocId = uidToDocId.get(l1Uid);
    const legActive = countQualifiedAtDepthUnderLeg(
      l1Uid,
      l1DocId,
      rules.depth,
      childrenByParentKey,
      uidToDocId,
      qualifiedUids
    );
    teamScore += Math.min(rules.maxPerLeg, legActive);
  }
  return teamScore;
}
